import { configureStore } from '@reduxjs/toolkit'
import reducer from './reducer'
import { useDispatch, useSelector } from 'react-redux'

const store = configureStore({
    reducer,
    devTools: process.env.NODE_ENV !== 'production'
})

export const useAppSelector = useSelector
export const useAppDispatch = () => useDispatch()
export default store
